<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div id="exactSearch" class="flex gap-3 p-3 rounded-2xl">
    <span class="text-gray-700 font-medium align-content-center">
      {{ $t("exactSearch") }}
    </span>
    <PrimeToggleButton
      v-model="exactSearch"
      binary
      :onLabel="$t(`enabled`)"
      :offLabel="$t(`disabled`)"
      class="rounded-xl"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import PrimeToggleButton from "primevue/togglebutton";
import { mapActions, mapState } from "pinia";
import { useSearchStore } from "@/stores/search.js";

export default {
  name: "ExactSearch",
  components: {
    PrimeToggleButton,
  },
  props: {
    disabled: { type: Boolean, default: false },
  },
  watch: {
    disabled(isDisabled) {
      if (isDisabled && this.exactSearch) {
        this.exactSearch = false;
      }
    },
  },
  emits: ["change-exact-search-settings"],
  computed: {
    ...mapState(useSearchStore, ["isExactSearchActivated"]),
    exactSearch: {
      get() {
        return this.isExactSearchActivated;
      },
      set(newValue) {
        this.setIsExactSearchActivated(newValue);
        this.$emit("change-exact-search-settings", newValue);
      },
    },
  },
  methods: {
    ...mapActions(useSearchStore, ["setIsExactSearchActivated"]),
  },
};
</script>
<style scoped></style>
